var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconArrowDown = function SvgIconArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B6BDCC",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m1 1 5 4 5-4"
  })));
};
export default SvgIconArrowDown;